import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TextField = ({
  id,
  name,
  type = 'text',
  value,
  defaultValue,
  hintText,
  errors = [],
  disabled,
  onChange = () => {},
  onKeyDown = () => {},
  className,
  maxLength,
  autoComplete = false,
  currency = '',
  theme = ''
}) => {
  const textFieldTypes = {
    text: 'text',
    password: 'password',
    tel: 'tel'
  };

  const textFieldClassNames = classNames('text-field', {
    'text-field--disabled': disabled,
    'text-field--error': errors.length,
    [`text-field--theme-${theme}`]: theme.length
  }, className);

  const handleChange = (e) => {
    if (!disabled) onChange(e);
  };

  const handleKeyDown = (e) => {
    if (!disabled) onKeyDown(e);
  };

  const input = (
    <input
      id={id}
      name={name}
      type={(textFieldTypes[type]) ? textFieldTypes[type] : textFieldTypes.text}
      value={value}
      defaultValue={defaultValue}
      placeholder={hintText}
      autoComplete={autoComplete ? 'on' : 'off'}
      autoCorrect="off"
      disabled={disabled}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      className="text-field__input"
      maxLength={maxLength}
    />
  );

  let i = 0;
  return (
    <div className={textFieldClassNames}>
      {currency.length ? (
        <div className="text-field__currency-mode">
          {input}
          <div className="text-field__currency-value">{currency}</div>
        </div>
      ) : input}
      <ul className="text-field__errors-list">
        {errors.map(e => (
          <li key={i++}>{e}</li>
        ))}
      </ul>
    </div>
  );
};

TextField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  hintText: PropTypes.node,
  errors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  autoComplete: PropTypes.bool,
  theme: PropTypes.string,
  currency: PropTypes.string
};

export default TextField;
